import {
  VStack,
  HStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Center,
  Heading,
  Box,
  ModalFooter,
} from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';

type OrderPaymentModalProps = {
  last4Digits?: string;
  createdAt: string;
  isOpen: boolean;
  onClose: () => void;
};

// 信用卡付款明細
export default function OrderPaymentModal({
  last4Digits,
  createdAt,
  isOpen,
  onClose,
}: OrderPaymentModalProps) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Center mt={4}>
            <VStack spacing={4} justify="space-between" my={3}>
              <Heading fontSize="xl">{t('payment.detailModal.title')}</Heading>
              {last4Digits && (
                <Text fontSize="sm" color="wsGray.500">
                  {t('payment.detailModal.note')}
                  {last4Digits}
                </Text>
              )}
              <Text fontSize="sm" color="wsGray.500">
                {t('payment.paymentAt', { paymentAt: createdAt })}
              </Text>
            </VStack>
          </Center>
        </ModalBody>
        <ModalFooter borderTopWidth="1px" borderTopColor="admin.gray.300" justifyContent="center">
          <HStack align="stretch" w="full" spacing={0}>
            <Box as="button" flex="1" onClick={onClose}>
              <Text fontSize="sm">{t('payment.detailModal.btn')}</Text>
            </Box>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
